import DropZone from './drop_zone'
import FileList from './file_list'
import HiddenInputs from './hidden_inputs'

export default ({
  DropZone,
  FileList,
  HiddenInputs
})
